/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../../routes/__root'
import { Route as Login_oldRouteImport } from './../../routes/login_old'
import { Route as R500RouteImport } from './../../routes/500'
import { Route as BeheerRouteRouteImport } from './../../routes/beheer/route'
import { Route as IndexRouteImport } from './../../routes/index'
import { Route as BeheerLabelsRouteImport } from './../../routes/beheer/labels'
import { Route as BeheerInstallatietypesRouteImport } from './../../routes/beheer/installatietypes'
import { Route as BeheerActiviteitenRouteImport } from './../../routes/beheer/activiteiten'
import { Route as BedrijfLineageIdViewerRouteRouteImport } from './../../routes/$bedrijfLineageId.viewer/route'
import { Route as BeheerStandaardtekstenGrondslagIdRouteImport } from './../../routes/beheer/standaardteksten.$grondslagId'
import { Route as BeheerLabelsMapIdRouteImport } from './../../routes/beheer/labels.$mapId'
import { Route as BedrijfLineageIdBedrijfLayoutRouteImport } from './../../routes/$bedrijfLineageId.bedrijf/_layout'
import { Route as BedrijfLineageIdViewerVigerendRouteRouteImport } from './../../routes/$bedrijfLineageId.viewer/vigerend/route'
import { Route as BedrijfLineageIdEditorBesluitIdRouteRouteImport } from './../../routes/$bedrijfLineageId.editor.$besluitId/route'
import { Route as BedrijfLineageIdViewerVigerendIndexRouteImport } from './../../routes/$bedrijfLineageId.viewer/vigerend/index'
import { Route as BeheerStandaardtekstenGrondslagIdMapIdRouteImport } from './../../routes/beheer/standaardteksten.$grondslagId.$mapId'
import { Route as BeheerLabelsMapIdNestedMapIdRouteImport } from './../../routes/beheer/labels.$mapId.$nestedMapId'
import { Route as BedrijfLineageIdEditorBesluitIdRedirectRouteImport } from './../../routes/$bedrijfLineageId.editor.$besluitId/redirect'
import { Route as BedrijfLineageIdEditorBesluitIdRechtsmiddelenRouteImport } from './../../routes/$bedrijfLineageId.editor.$besluitId/rechtsmiddelen'
import { Route as BedrijfLineageIdEditorBesluitIdProcedureleOverwegingenRouteImport } from './../../routes/$bedrijfLineageId.editor.$besluitId/procedurele-overwegingen'
import { Route as BedrijfLineageIdEditorBesluitIdOverigeOverwegingenRouteImport } from './../../routes/$bedrijfLineageId.editor.$besluitId/overige-overwegingen'
import { Route as BedrijfLineageIdEditorBesluitIdBijlageRouteImport } from './../../routes/$bedrijfLineageId.editor.$besluitId/bijlage'
import { Route as BedrijfLineageIdEditorBesluitIdBesluittekstRouteImport } from './../../routes/$bedrijfLineageId.editor.$besluitId/besluittekst'
import { Route as BedrijfLineageIdEditorBesluitIdBegrippenRouteImport } from './../../routes/$bedrijfLineageId.editor.$besluitId/begrippen'
import { Route as BedrijfLineageIdEditorBesluitIdAlgemeenToetsingskaderRouteImport } from './../../routes/$bedrijfLineageId.editor.$besluitId/algemeen-toetsingskader'
import { Route as BedrijfLineageIdBedrijfLayoutOverzichtRouteImport } from './../../routes/$bedrijfLineageId.bedrijf/_layout.overzicht'
import { Route as BedrijfLineageIdBedrijfLayoutOntwerpenRouteImport } from './../../routes/$bedrijfLineageId.bedrijf/_layout.ontwerpen'
import { Route as BedrijfLineageIdBedrijfLayoutHistorischeBesluitenRouteImport } from './../../routes/$bedrijfLineageId.bedrijf/_layout.historische-besluiten'
import { Route as BedrijfLineageIdBedrijfLayoutBesluitenRouteImport } from './../../routes/$bedrijfLineageId.bedrijf/_layout.besluiten'
import { Route as BedrijfLineageIdViewerVigerendLabelsHoofdstukLineageIdRouteImport } from './../../routes/$bedrijfLineageId.viewer/vigerend/labels.$hoofdstukLineageId'
import { Route as BedrijfLineageIdViewerVigerendInhoudHoofdstukLineageIdRouteImport } from './../../routes/$bedrijfLineageId.viewer/vigerend/inhoud.$hoofdstukLineageId'
import { Route as BedrijfLineageIdViewerBesluitBesluitIdLayoutRouteImport } from './../../routes/$bedrijfLineageId.viewer/besluit.$besluitId/_layout'
import { Route as BedrijfLineageIdEditorBesluitIdVoorschriftenHoofdstukRouteImport } from './../../routes/$bedrijfLineageId.editor.$besluitId/voorschriften.hoofdstuk'
import { Route as BedrijfLineageIdEditorBesluitIdVoorschriftenHoofdstukLineageIdRouteImport } from './../../routes/$bedrijfLineageId.editor.$besluitId/voorschriften.$hoofdstukLineageId'
import { Route as BedrijfLineageIdEditorBesluitIdLabelsHoofdstukLineageIdRouteImport } from './../../routes/$bedrijfLineageId.editor.$besluitId/labels.$hoofdstukLineageId'
import { Route as BedrijfLineageIdEditorBesluitIdInhoudelijkeOverwegingenHoofdstukLineageIdRouteImport } from './../../routes/$bedrijfLineageId.editor.$besluitId/inhoudelijke-overwegingen.$hoofdstukLineageId'
import { Route as BeheerStandaardtekstenGrondslagIdMapIdSectieIdVoorschriftenRouteImport } from './../../routes/beheer/standaardteksten.$grondslagId.$mapId.$sectieId.voorschriften'
import { Route as BeheerStandaardtekstenGrondslagIdMapIdSectieIdInhoudelijkeOverwegingenRouteImport } from './../../routes/beheer/standaardteksten.$grondslagId.$mapId.$sectieId.inhoudelijke-overwegingen'
import { Route as BedrijfLineageIdViewerBesluitBesluitIdLayoutRedirectRouteImport } from './../../routes/$bedrijfLineageId.viewer/besluit.$besluitId/_layout.redirect'
import { Route as BedrijfLineageIdViewerBesluitBesluitIdLayoutRechtsmiddelenRouteImport } from './../../routes/$bedrijfLineageId.viewer/besluit.$besluitId/_layout.rechtsmiddelen'
import { Route as BedrijfLineageIdViewerBesluitBesluitIdLayoutProcedureleOverwegingenRouteImport } from './../../routes/$bedrijfLineageId.viewer/besluit.$besluitId/_layout.procedurele-overwegingen'
import { Route as BedrijfLineageIdViewerBesluitBesluitIdLayoutOverigeOverwegingenRouteImport } from './../../routes/$bedrijfLineageId.viewer/besluit.$besluitId/_layout.overige-overwegingen'
import { Route as BedrijfLineageIdViewerBesluitBesluitIdLayoutBijlageRouteImport } from './../../routes/$bedrijfLineageId.viewer/besluit.$besluitId/_layout.bijlage'
import { Route as BedrijfLineageIdViewerBesluitBesluitIdLayoutBesluittekstRouteImport } from './../../routes/$bedrijfLineageId.viewer/besluit.$besluitId/_layout.besluittekst'
import { Route as BedrijfLineageIdViewerBesluitBesluitIdLayoutBegrippenRouteImport } from './../../routes/$bedrijfLineageId.viewer/besluit.$besluitId/_layout.begrippen'
import { Route as BedrijfLineageIdViewerBesluitBesluitIdLayoutAlgemeenToetsingskaderRouteImport } from './../../routes/$bedrijfLineageId.viewer/besluit.$besluitId/_layout.algemeen-toetsingskader'
import { Route as BedrijfLineageIdViewerBesluitBesluitIdLayoutVoorschriftenHoofdstukIdRouteImport } from './../../routes/$bedrijfLineageId.viewer/besluit.$besluitId/_layout.voorschriften.$hoofdstukId'
import { Route as BedrijfLineageIdViewerBesluitBesluitIdLayoutLabelsHoofdstukIdRouteImport } from './../../routes/$bedrijfLineageId.viewer/besluit.$besluitId/_layout.labels.$hoofdstukId'
import { Route as BedrijfLineageIdViewerBesluitBesluitIdLayoutInhoudelijkeOverwegingenHoofdstukIdRouteImport } from './../../routes/$bedrijfLineageId.viewer/besluit.$besluitId/_layout.inhoudelijke-overwegingen.$hoofdstukId'

const Login_oldRoute = Login_oldRouteImport.update({
  id: '/login_old',
  path: '/login_old',
  getParentRoute: () => rootRouteImport,
} as any)
const R500Route = R500RouteImport.update({
  id: '/500',
  path: '/500',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerRouteRoute = BeheerRouteRouteImport.update({
  id: '/beheer',
  path: '/beheer',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerLabelsRoute = BeheerLabelsRouteImport.update({
  id: '/labels',
  path: '/labels',
  getParentRoute: () => BeheerRouteRoute,
} as any)
const BeheerInstallatietypesRoute = BeheerInstallatietypesRouteImport.update({
  id: '/installatietypes',
  path: '/installatietypes',
  getParentRoute: () => BeheerRouteRoute,
} as any)
const BeheerActiviteitenRoute = BeheerActiviteitenRouteImport.update({
  id: '/activiteiten',
  path: '/activiteiten',
  getParentRoute: () => BeheerRouteRoute,
} as any)
const BedrijfLineageIdViewerRouteRoute =
  BedrijfLineageIdViewerRouteRouteImport.update({
    id: '/$bedrijfLineageId/viewer',
    path: '/$bedrijfLineageId/viewer',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerStandaardtekstenGrondslagIdRoute =
  BeheerStandaardtekstenGrondslagIdRouteImport.update({
    id: '/standaardteksten/$grondslagId',
    path: '/standaardteksten/$grondslagId',
    getParentRoute: () => BeheerRouteRoute,
  } as any)
const BeheerLabelsMapIdRoute = BeheerLabelsMapIdRouteImport.update({
  id: '/$mapId',
  path: '/$mapId',
  getParentRoute: () => BeheerLabelsRoute,
} as any)
const BedrijfLineageIdBedrijfLayoutRoute =
  BedrijfLineageIdBedrijfLayoutRouteImport.update({
    id: '/$bedrijfLineageId/bedrijf/_layout',
    path: '/$bedrijfLineageId/bedrijf',
    getParentRoute: () => rootRouteImport,
  } as any)
const BedrijfLineageIdViewerVigerendRouteRoute =
  BedrijfLineageIdViewerVigerendRouteRouteImport.update({
    id: '/vigerend',
    path: '/vigerend',
    getParentRoute: () => BedrijfLineageIdViewerRouteRoute,
  } as any)
const BedrijfLineageIdEditorBesluitIdRouteRoute =
  BedrijfLineageIdEditorBesluitIdRouteRouteImport.update({
    id: '/$bedrijfLineageId/editor/$besluitId',
    path: '/$bedrijfLineageId/editor/$besluitId',
    getParentRoute: () => rootRouteImport,
  } as any)
const BedrijfLineageIdViewerVigerendIndexRoute =
  BedrijfLineageIdViewerVigerendIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BedrijfLineageIdViewerVigerendRouteRoute,
  } as any)
const BeheerStandaardtekstenGrondslagIdMapIdRoute =
  BeheerStandaardtekstenGrondslagIdMapIdRouteImport.update({
    id: '/$mapId',
    path: '/$mapId',
    getParentRoute: () => BeheerStandaardtekstenGrondslagIdRoute,
  } as any)
const BeheerLabelsMapIdNestedMapIdRoute =
  BeheerLabelsMapIdNestedMapIdRouteImport.update({
    id: '/$nestedMapId',
    path: '/$nestedMapId',
    getParentRoute: () => BeheerLabelsMapIdRoute,
  } as any)
const BedrijfLineageIdEditorBesluitIdRedirectRoute =
  BedrijfLineageIdEditorBesluitIdRedirectRouteImport.update({
    id: '/redirect',
    path: '/redirect',
    getParentRoute: () => BedrijfLineageIdEditorBesluitIdRouteRoute,
  } as any)
const BedrijfLineageIdEditorBesluitIdRechtsmiddelenRoute =
  BedrijfLineageIdEditorBesluitIdRechtsmiddelenRouteImport.update({
    id: '/rechtsmiddelen',
    path: '/rechtsmiddelen',
    getParentRoute: () => BedrijfLineageIdEditorBesluitIdRouteRoute,
  } as any)
const BedrijfLineageIdEditorBesluitIdProcedureleOverwegingenRoute =
  BedrijfLineageIdEditorBesluitIdProcedureleOverwegingenRouteImport.update({
    id: '/procedurele-overwegingen',
    path: '/procedurele-overwegingen',
    getParentRoute: () => BedrijfLineageIdEditorBesluitIdRouteRoute,
  } as any)
const BedrijfLineageIdEditorBesluitIdOverigeOverwegingenRoute =
  BedrijfLineageIdEditorBesluitIdOverigeOverwegingenRouteImport.update({
    id: '/overige-overwegingen',
    path: '/overige-overwegingen',
    getParentRoute: () => BedrijfLineageIdEditorBesluitIdRouteRoute,
  } as any)
const BedrijfLineageIdEditorBesluitIdBijlageRoute =
  BedrijfLineageIdEditorBesluitIdBijlageRouteImport.update({
    id: '/bijlage',
    path: '/bijlage',
    getParentRoute: () => BedrijfLineageIdEditorBesluitIdRouteRoute,
  } as any)
const BedrijfLineageIdEditorBesluitIdBesluittekstRoute =
  BedrijfLineageIdEditorBesluitIdBesluittekstRouteImport.update({
    id: '/besluittekst',
    path: '/besluittekst',
    getParentRoute: () => BedrijfLineageIdEditorBesluitIdRouteRoute,
  } as any)
const BedrijfLineageIdEditorBesluitIdBegrippenRoute =
  BedrijfLineageIdEditorBesluitIdBegrippenRouteImport.update({
    id: '/begrippen',
    path: '/begrippen',
    getParentRoute: () => BedrijfLineageIdEditorBesluitIdRouteRoute,
  } as any)
const BedrijfLineageIdEditorBesluitIdAlgemeenToetsingskaderRoute =
  BedrijfLineageIdEditorBesluitIdAlgemeenToetsingskaderRouteImport.update({
    id: '/algemeen-toetsingskader',
    path: '/algemeen-toetsingskader',
    getParentRoute: () => BedrijfLineageIdEditorBesluitIdRouteRoute,
  } as any)
const BedrijfLineageIdBedrijfLayoutOverzichtRoute =
  BedrijfLineageIdBedrijfLayoutOverzichtRouteImport.update({
    id: '/overzicht',
    path: '/overzicht',
    getParentRoute: () => BedrijfLineageIdBedrijfLayoutRoute,
  } as any)
const BedrijfLineageIdBedrijfLayoutOntwerpenRoute =
  BedrijfLineageIdBedrijfLayoutOntwerpenRouteImport.update({
    id: '/ontwerpen',
    path: '/ontwerpen',
    getParentRoute: () => BedrijfLineageIdBedrijfLayoutRoute,
  } as any)
const BedrijfLineageIdBedrijfLayoutHistorischeBesluitenRoute =
  BedrijfLineageIdBedrijfLayoutHistorischeBesluitenRouteImport.update({
    id: '/historische-besluiten',
    path: '/historische-besluiten',
    getParentRoute: () => BedrijfLineageIdBedrijfLayoutRoute,
  } as any)
const BedrijfLineageIdBedrijfLayoutBesluitenRoute =
  BedrijfLineageIdBedrijfLayoutBesluitenRouteImport.update({
    id: '/besluiten',
    path: '/besluiten',
    getParentRoute: () => BedrijfLineageIdBedrijfLayoutRoute,
  } as any)
const BedrijfLineageIdViewerVigerendLabelsHoofdstukLineageIdRoute =
  BedrijfLineageIdViewerVigerendLabelsHoofdstukLineageIdRouteImport.update({
    id: '/labels/$hoofdstukLineageId',
    path: '/labels/$hoofdstukLineageId',
    getParentRoute: () => BedrijfLineageIdViewerVigerendRouteRoute,
  } as any)
const BedrijfLineageIdViewerVigerendInhoudHoofdstukLineageIdRoute =
  BedrijfLineageIdViewerVigerendInhoudHoofdstukLineageIdRouteImport.update({
    id: '/inhoud/$hoofdstukLineageId',
    path: '/inhoud/$hoofdstukLineageId',
    getParentRoute: () => BedrijfLineageIdViewerVigerendRouteRoute,
  } as any)
const BedrijfLineageIdViewerBesluitBesluitIdLayoutRoute =
  BedrijfLineageIdViewerBesluitBesluitIdLayoutRouteImport.update({
    id: '/besluit/$besluitId/_layout',
    path: '/besluit/$besluitId',
    getParentRoute: () => BedrijfLineageIdViewerRouteRoute,
  } as any)
const BedrijfLineageIdEditorBesluitIdVoorschriftenHoofdstukRoute =
  BedrijfLineageIdEditorBesluitIdVoorschriftenHoofdstukRouteImport.update({
    id: '/voorschriften/hoofdstuk',
    path: '/voorschriften/hoofdstuk',
    getParentRoute: () => BedrijfLineageIdEditorBesluitIdRouteRoute,
  } as any)
const BedrijfLineageIdEditorBesluitIdVoorschriftenHoofdstukLineageIdRoute =
  BedrijfLineageIdEditorBesluitIdVoorschriftenHoofdstukLineageIdRouteImport.update(
    {
      id: '/voorschriften/$hoofdstukLineageId',
      path: '/voorschriften/$hoofdstukLineageId',
      getParentRoute: () => BedrijfLineageIdEditorBesluitIdRouteRoute,
    } as any,
  )
const BedrijfLineageIdEditorBesluitIdLabelsHoofdstukLineageIdRoute =
  BedrijfLineageIdEditorBesluitIdLabelsHoofdstukLineageIdRouteImport.update({
    id: '/labels/$hoofdstukLineageId',
    path: '/labels/$hoofdstukLineageId',
    getParentRoute: () => BedrijfLineageIdEditorBesluitIdRouteRoute,
  } as any)
const BedrijfLineageIdEditorBesluitIdInhoudelijkeOverwegingenHoofdstukLineageIdRoute =
  BedrijfLineageIdEditorBesluitIdInhoudelijkeOverwegingenHoofdstukLineageIdRouteImport.update(
    {
      id: '/inhoudelijke-overwegingen/$hoofdstukLineageId',
      path: '/inhoudelijke-overwegingen/$hoofdstukLineageId',
      getParentRoute: () => BedrijfLineageIdEditorBesluitIdRouteRoute,
    } as any,
  )
const BeheerStandaardtekstenGrondslagIdMapIdSectieIdVoorschriftenRoute =
  BeheerStandaardtekstenGrondslagIdMapIdSectieIdVoorschriftenRouteImport.update(
    {
      id: '/$sectieId/voorschriften',
      path: '/$sectieId/voorschriften',
      getParentRoute: () => BeheerStandaardtekstenGrondslagIdMapIdRoute,
    } as any,
  )
const BeheerStandaardtekstenGrondslagIdMapIdSectieIdInhoudelijkeOverwegingenRoute =
  BeheerStandaardtekstenGrondslagIdMapIdSectieIdInhoudelijkeOverwegingenRouteImport.update(
    {
      id: '/$sectieId/inhoudelijke-overwegingen',
      path: '/$sectieId/inhoudelijke-overwegingen',
      getParentRoute: () => BeheerStandaardtekstenGrondslagIdMapIdRoute,
    } as any,
  )
const BedrijfLineageIdViewerBesluitBesluitIdLayoutRedirectRoute =
  BedrijfLineageIdViewerBesluitBesluitIdLayoutRedirectRouteImport.update({
    id: '/redirect',
    path: '/redirect',
    getParentRoute: () => BedrijfLineageIdViewerBesluitBesluitIdLayoutRoute,
  } as any)
const BedrijfLineageIdViewerBesluitBesluitIdLayoutRechtsmiddelenRoute =
  BedrijfLineageIdViewerBesluitBesluitIdLayoutRechtsmiddelenRouteImport.update({
    id: '/rechtsmiddelen',
    path: '/rechtsmiddelen',
    getParentRoute: () => BedrijfLineageIdViewerBesluitBesluitIdLayoutRoute,
  } as any)
const BedrijfLineageIdViewerBesluitBesluitIdLayoutProcedureleOverwegingenRoute =
  BedrijfLineageIdViewerBesluitBesluitIdLayoutProcedureleOverwegingenRouteImport.update(
    {
      id: '/procedurele-overwegingen',
      path: '/procedurele-overwegingen',
      getParentRoute: () => BedrijfLineageIdViewerBesluitBesluitIdLayoutRoute,
    } as any,
  )
const BedrijfLineageIdViewerBesluitBesluitIdLayoutOverigeOverwegingenRoute =
  BedrijfLineageIdViewerBesluitBesluitIdLayoutOverigeOverwegingenRouteImport.update(
    {
      id: '/overige-overwegingen',
      path: '/overige-overwegingen',
      getParentRoute: () => BedrijfLineageIdViewerBesluitBesluitIdLayoutRoute,
    } as any,
  )
const BedrijfLineageIdViewerBesluitBesluitIdLayoutBijlageRoute =
  BedrijfLineageIdViewerBesluitBesluitIdLayoutBijlageRouteImport.update({
    id: '/bijlage',
    path: '/bijlage',
    getParentRoute: () => BedrijfLineageIdViewerBesluitBesluitIdLayoutRoute,
  } as any)
const BedrijfLineageIdViewerBesluitBesluitIdLayoutBesluittekstRoute =
  BedrijfLineageIdViewerBesluitBesluitIdLayoutBesluittekstRouteImport.update({
    id: '/besluittekst',
    path: '/besluittekst',
    getParentRoute: () => BedrijfLineageIdViewerBesluitBesluitIdLayoutRoute,
  } as any)
const BedrijfLineageIdViewerBesluitBesluitIdLayoutBegrippenRoute =
  BedrijfLineageIdViewerBesluitBesluitIdLayoutBegrippenRouteImport.update({
    id: '/begrippen',
    path: '/begrippen',
    getParentRoute: () => BedrijfLineageIdViewerBesluitBesluitIdLayoutRoute,
  } as any)
const BedrijfLineageIdViewerBesluitBesluitIdLayoutAlgemeenToetsingskaderRoute =
  BedrijfLineageIdViewerBesluitBesluitIdLayoutAlgemeenToetsingskaderRouteImport.update(
    {
      id: '/algemeen-toetsingskader',
      path: '/algemeen-toetsingskader',
      getParentRoute: () => BedrijfLineageIdViewerBesluitBesluitIdLayoutRoute,
    } as any,
  )
const BedrijfLineageIdViewerBesluitBesluitIdLayoutVoorschriftenHoofdstukIdRoute =
  BedrijfLineageIdViewerBesluitBesluitIdLayoutVoorschriftenHoofdstukIdRouteImport.update(
    {
      id: '/voorschriften/$hoofdstukId',
      path: '/voorschriften/$hoofdstukId',
      getParentRoute: () => BedrijfLineageIdViewerBesluitBesluitIdLayoutRoute,
    } as any,
  )
const BedrijfLineageIdViewerBesluitBesluitIdLayoutLabelsHoofdstukIdRoute =
  BedrijfLineageIdViewerBesluitBesluitIdLayoutLabelsHoofdstukIdRouteImport.update(
    {
      id: '/labels/$hoofdstukId',
      path: '/labels/$hoofdstukId',
      getParentRoute: () => BedrijfLineageIdViewerBesluitBesluitIdLayoutRoute,
    } as any,
  )
const BedrijfLineageIdViewerBesluitBesluitIdLayoutInhoudelijkeOverwegingenHoofdstukIdRoute =
  BedrijfLineageIdViewerBesluitBesluitIdLayoutInhoudelijkeOverwegingenHoofdstukIdRouteImport.update(
    {
      id: '/inhoudelijke-overwegingen/$hoofdstukId',
      path: '/inhoudelijke-overwegingen/$hoofdstukId',
      getParentRoute: () => BedrijfLineageIdViewerBesluitBesluitIdLayoutRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/beheer': typeof BeheerRouteRouteWithChildren
  '/500': typeof R500Route
  '/login_old': typeof Login_oldRoute
  '/$bedrijfLineageId/viewer': typeof BedrijfLineageIdViewerRouteRouteWithChildren
  '/beheer/activiteiten': typeof BeheerActiviteitenRoute
  '/beheer/installatietypes': typeof BeheerInstallatietypesRoute
  '/beheer/labels': typeof BeheerLabelsRouteWithChildren
  '/$bedrijfLineageId/editor/$besluitId': typeof BedrijfLineageIdEditorBesluitIdRouteRouteWithChildren
  '/$bedrijfLineageId/viewer/vigerend': typeof BedrijfLineageIdViewerVigerendRouteRouteWithChildren
  '/$bedrijfLineageId/bedrijf': typeof BedrijfLineageIdBedrijfLayoutRouteWithChildren
  '/beheer/labels/$mapId': typeof BeheerLabelsMapIdRouteWithChildren
  '/beheer/standaardteksten/$grondslagId': typeof BeheerStandaardtekstenGrondslagIdRouteWithChildren
  '/$bedrijfLineageId/bedrijf/besluiten': typeof BedrijfLineageIdBedrijfLayoutBesluitenRoute
  '/$bedrijfLineageId/bedrijf/historische-besluiten': typeof BedrijfLineageIdBedrijfLayoutHistorischeBesluitenRoute
  '/$bedrijfLineageId/bedrijf/ontwerpen': typeof BedrijfLineageIdBedrijfLayoutOntwerpenRoute
  '/$bedrijfLineageId/bedrijf/overzicht': typeof BedrijfLineageIdBedrijfLayoutOverzichtRoute
  '/$bedrijfLineageId/editor/$besluitId/algemeen-toetsingskader': typeof BedrijfLineageIdEditorBesluitIdAlgemeenToetsingskaderRoute
  '/$bedrijfLineageId/editor/$besluitId/begrippen': typeof BedrijfLineageIdEditorBesluitIdBegrippenRoute
  '/$bedrijfLineageId/editor/$besluitId/besluittekst': typeof BedrijfLineageIdEditorBesluitIdBesluittekstRoute
  '/$bedrijfLineageId/editor/$besluitId/bijlage': typeof BedrijfLineageIdEditorBesluitIdBijlageRoute
  '/$bedrijfLineageId/editor/$besluitId/overige-overwegingen': typeof BedrijfLineageIdEditorBesluitIdOverigeOverwegingenRoute
  '/$bedrijfLineageId/editor/$besluitId/procedurele-overwegingen': typeof BedrijfLineageIdEditorBesluitIdProcedureleOverwegingenRoute
  '/$bedrijfLineageId/editor/$besluitId/rechtsmiddelen': typeof BedrijfLineageIdEditorBesluitIdRechtsmiddelenRoute
  '/$bedrijfLineageId/editor/$besluitId/redirect': typeof BedrijfLineageIdEditorBesluitIdRedirectRoute
  '/beheer/labels/$mapId/$nestedMapId': typeof BeheerLabelsMapIdNestedMapIdRoute
  '/beheer/standaardteksten/$grondslagId/$mapId': typeof BeheerStandaardtekstenGrondslagIdMapIdRouteWithChildren
  '/$bedrijfLineageId/viewer/vigerend/': typeof BedrijfLineageIdViewerVigerendIndexRoute
  '/$bedrijfLineageId/editor/$besluitId/inhoudelijke-overwegingen/$hoofdstukLineageId': typeof BedrijfLineageIdEditorBesluitIdInhoudelijkeOverwegingenHoofdstukLineageIdRoute
  '/$bedrijfLineageId/editor/$besluitId/labels/$hoofdstukLineageId': typeof BedrijfLineageIdEditorBesluitIdLabelsHoofdstukLineageIdRoute
  '/$bedrijfLineageId/editor/$besluitId/voorschriften/$hoofdstukLineageId': typeof BedrijfLineageIdEditorBesluitIdVoorschriftenHoofdstukLineageIdRoute
  '/$bedrijfLineageId/editor/$besluitId/voorschriften/hoofdstuk': typeof BedrijfLineageIdEditorBesluitIdVoorschriftenHoofdstukRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutRouteWithChildren
  '/$bedrijfLineageId/viewer/vigerend/inhoud/$hoofdstukLineageId': typeof BedrijfLineageIdViewerVigerendInhoudHoofdstukLineageIdRoute
  '/$bedrijfLineageId/viewer/vigerend/labels/$hoofdstukLineageId': typeof BedrijfLineageIdViewerVigerendLabelsHoofdstukLineageIdRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/algemeen-toetsingskader': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutAlgemeenToetsingskaderRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/begrippen': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutBegrippenRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/besluittekst': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutBesluittekstRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/bijlage': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutBijlageRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/overige-overwegingen': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutOverigeOverwegingenRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/procedurele-overwegingen': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutProcedureleOverwegingenRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/rechtsmiddelen': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutRechtsmiddelenRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/redirect': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutRedirectRoute
  '/beheer/standaardteksten/$grondslagId/$mapId/$sectieId/inhoudelijke-overwegingen': typeof BeheerStandaardtekstenGrondslagIdMapIdSectieIdInhoudelijkeOverwegingenRoute
  '/beheer/standaardteksten/$grondslagId/$mapId/$sectieId/voorschriften': typeof BeheerStandaardtekstenGrondslagIdMapIdSectieIdVoorschriftenRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/inhoudelijke-overwegingen/$hoofdstukId': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutInhoudelijkeOverwegingenHoofdstukIdRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/labels/$hoofdstukId': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutLabelsHoofdstukIdRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/voorschriften/$hoofdstukId': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutVoorschriftenHoofdstukIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/beheer': typeof BeheerRouteRouteWithChildren
  '/500': typeof R500Route
  '/login_old': typeof Login_oldRoute
  '/$bedrijfLineageId/viewer': typeof BedrijfLineageIdViewerRouteRouteWithChildren
  '/beheer/activiteiten': typeof BeheerActiviteitenRoute
  '/beheer/installatietypes': typeof BeheerInstallatietypesRoute
  '/beheer/labels': typeof BeheerLabelsRouteWithChildren
  '/$bedrijfLineageId/editor/$besluitId': typeof BedrijfLineageIdEditorBesluitIdRouteRouteWithChildren
  '/$bedrijfLineageId/bedrijf': typeof BedrijfLineageIdBedrijfLayoutRouteWithChildren
  '/beheer/labels/$mapId': typeof BeheerLabelsMapIdRouteWithChildren
  '/beheer/standaardteksten/$grondslagId': typeof BeheerStandaardtekstenGrondslagIdRouteWithChildren
  '/$bedrijfLineageId/bedrijf/besluiten': typeof BedrijfLineageIdBedrijfLayoutBesluitenRoute
  '/$bedrijfLineageId/bedrijf/historische-besluiten': typeof BedrijfLineageIdBedrijfLayoutHistorischeBesluitenRoute
  '/$bedrijfLineageId/bedrijf/ontwerpen': typeof BedrijfLineageIdBedrijfLayoutOntwerpenRoute
  '/$bedrijfLineageId/bedrijf/overzicht': typeof BedrijfLineageIdBedrijfLayoutOverzichtRoute
  '/$bedrijfLineageId/editor/$besluitId/algemeen-toetsingskader': typeof BedrijfLineageIdEditorBesluitIdAlgemeenToetsingskaderRoute
  '/$bedrijfLineageId/editor/$besluitId/begrippen': typeof BedrijfLineageIdEditorBesluitIdBegrippenRoute
  '/$bedrijfLineageId/editor/$besluitId/besluittekst': typeof BedrijfLineageIdEditorBesluitIdBesluittekstRoute
  '/$bedrijfLineageId/editor/$besluitId/bijlage': typeof BedrijfLineageIdEditorBesluitIdBijlageRoute
  '/$bedrijfLineageId/editor/$besluitId/overige-overwegingen': typeof BedrijfLineageIdEditorBesluitIdOverigeOverwegingenRoute
  '/$bedrijfLineageId/editor/$besluitId/procedurele-overwegingen': typeof BedrijfLineageIdEditorBesluitIdProcedureleOverwegingenRoute
  '/$bedrijfLineageId/editor/$besluitId/rechtsmiddelen': typeof BedrijfLineageIdEditorBesluitIdRechtsmiddelenRoute
  '/$bedrijfLineageId/editor/$besluitId/redirect': typeof BedrijfLineageIdEditorBesluitIdRedirectRoute
  '/beheer/labels/$mapId/$nestedMapId': typeof BeheerLabelsMapIdNestedMapIdRoute
  '/beheer/standaardteksten/$grondslagId/$mapId': typeof BeheerStandaardtekstenGrondslagIdMapIdRouteWithChildren
  '/$bedrijfLineageId/viewer/vigerend': typeof BedrijfLineageIdViewerVigerendIndexRoute
  '/$bedrijfLineageId/editor/$besluitId/inhoudelijke-overwegingen/$hoofdstukLineageId': typeof BedrijfLineageIdEditorBesluitIdInhoudelijkeOverwegingenHoofdstukLineageIdRoute
  '/$bedrijfLineageId/editor/$besluitId/labels/$hoofdstukLineageId': typeof BedrijfLineageIdEditorBesluitIdLabelsHoofdstukLineageIdRoute
  '/$bedrijfLineageId/editor/$besluitId/voorschriften/$hoofdstukLineageId': typeof BedrijfLineageIdEditorBesluitIdVoorschriftenHoofdstukLineageIdRoute
  '/$bedrijfLineageId/editor/$besluitId/voorschriften/hoofdstuk': typeof BedrijfLineageIdEditorBesluitIdVoorschriftenHoofdstukRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutRouteWithChildren
  '/$bedrijfLineageId/viewer/vigerend/inhoud/$hoofdstukLineageId': typeof BedrijfLineageIdViewerVigerendInhoudHoofdstukLineageIdRoute
  '/$bedrijfLineageId/viewer/vigerend/labels/$hoofdstukLineageId': typeof BedrijfLineageIdViewerVigerendLabelsHoofdstukLineageIdRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/algemeen-toetsingskader': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutAlgemeenToetsingskaderRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/begrippen': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutBegrippenRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/besluittekst': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutBesluittekstRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/bijlage': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutBijlageRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/overige-overwegingen': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutOverigeOverwegingenRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/procedurele-overwegingen': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutProcedureleOverwegingenRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/rechtsmiddelen': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutRechtsmiddelenRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/redirect': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutRedirectRoute
  '/beheer/standaardteksten/$grondslagId/$mapId/$sectieId/inhoudelijke-overwegingen': typeof BeheerStandaardtekstenGrondslagIdMapIdSectieIdInhoudelijkeOverwegingenRoute
  '/beheer/standaardteksten/$grondslagId/$mapId/$sectieId/voorschriften': typeof BeheerStandaardtekstenGrondslagIdMapIdSectieIdVoorschriftenRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/inhoudelijke-overwegingen/$hoofdstukId': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutInhoudelijkeOverwegingenHoofdstukIdRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/labels/$hoofdstukId': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutLabelsHoofdstukIdRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/voorschriften/$hoofdstukId': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutVoorschriftenHoofdstukIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/beheer': typeof BeheerRouteRouteWithChildren
  '/500': typeof R500Route
  '/login_old': typeof Login_oldRoute
  '/$bedrijfLineageId/viewer': typeof BedrijfLineageIdViewerRouteRouteWithChildren
  '/beheer/activiteiten': typeof BeheerActiviteitenRoute
  '/beheer/installatietypes': typeof BeheerInstallatietypesRoute
  '/beheer/labels': typeof BeheerLabelsRouteWithChildren
  '/$bedrijfLineageId/editor/$besluitId': typeof BedrijfLineageIdEditorBesluitIdRouteRouteWithChildren
  '/$bedrijfLineageId/viewer/vigerend': typeof BedrijfLineageIdViewerVigerendRouteRouteWithChildren
  '/$bedrijfLineageId/bedrijf/_layout': typeof BedrijfLineageIdBedrijfLayoutRouteWithChildren
  '/beheer/labels/$mapId': typeof BeheerLabelsMapIdRouteWithChildren
  '/beheer/standaardteksten/$grondslagId': typeof BeheerStandaardtekstenGrondslagIdRouteWithChildren
  '/$bedrijfLineageId/bedrijf/_layout/besluiten': typeof BedrijfLineageIdBedrijfLayoutBesluitenRoute
  '/$bedrijfLineageId/bedrijf/_layout/historische-besluiten': typeof BedrijfLineageIdBedrijfLayoutHistorischeBesluitenRoute
  '/$bedrijfLineageId/bedrijf/_layout/ontwerpen': typeof BedrijfLineageIdBedrijfLayoutOntwerpenRoute
  '/$bedrijfLineageId/bedrijf/_layout/overzicht': typeof BedrijfLineageIdBedrijfLayoutOverzichtRoute
  '/$bedrijfLineageId/editor/$besluitId/algemeen-toetsingskader': typeof BedrijfLineageIdEditorBesluitIdAlgemeenToetsingskaderRoute
  '/$bedrijfLineageId/editor/$besluitId/begrippen': typeof BedrijfLineageIdEditorBesluitIdBegrippenRoute
  '/$bedrijfLineageId/editor/$besluitId/besluittekst': typeof BedrijfLineageIdEditorBesluitIdBesluittekstRoute
  '/$bedrijfLineageId/editor/$besluitId/bijlage': typeof BedrijfLineageIdEditorBesluitIdBijlageRoute
  '/$bedrijfLineageId/editor/$besluitId/overige-overwegingen': typeof BedrijfLineageIdEditorBesluitIdOverigeOverwegingenRoute
  '/$bedrijfLineageId/editor/$besluitId/procedurele-overwegingen': typeof BedrijfLineageIdEditorBesluitIdProcedureleOverwegingenRoute
  '/$bedrijfLineageId/editor/$besluitId/rechtsmiddelen': typeof BedrijfLineageIdEditorBesluitIdRechtsmiddelenRoute
  '/$bedrijfLineageId/editor/$besluitId/redirect': typeof BedrijfLineageIdEditorBesluitIdRedirectRoute
  '/beheer/labels/$mapId/$nestedMapId': typeof BeheerLabelsMapIdNestedMapIdRoute
  '/beheer/standaardteksten/$grondslagId/$mapId': typeof BeheerStandaardtekstenGrondslagIdMapIdRouteWithChildren
  '/$bedrijfLineageId/viewer/vigerend/': typeof BedrijfLineageIdViewerVigerendIndexRoute
  '/$bedrijfLineageId/editor/$besluitId/inhoudelijke-overwegingen/$hoofdstukLineageId': typeof BedrijfLineageIdEditorBesluitIdInhoudelijkeOverwegingenHoofdstukLineageIdRoute
  '/$bedrijfLineageId/editor/$besluitId/labels/$hoofdstukLineageId': typeof BedrijfLineageIdEditorBesluitIdLabelsHoofdstukLineageIdRoute
  '/$bedrijfLineageId/editor/$besluitId/voorschriften/$hoofdstukLineageId': typeof BedrijfLineageIdEditorBesluitIdVoorschriftenHoofdstukLineageIdRoute
  '/$bedrijfLineageId/editor/$besluitId/voorschriften/hoofdstuk': typeof BedrijfLineageIdEditorBesluitIdVoorschriftenHoofdstukRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutRouteWithChildren
  '/$bedrijfLineageId/viewer/vigerend/inhoud/$hoofdstukLineageId': typeof BedrijfLineageIdViewerVigerendInhoudHoofdstukLineageIdRoute
  '/$bedrijfLineageId/viewer/vigerend/labels/$hoofdstukLineageId': typeof BedrijfLineageIdViewerVigerendLabelsHoofdstukLineageIdRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/algemeen-toetsingskader': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutAlgemeenToetsingskaderRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/begrippen': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutBegrippenRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/besluittekst': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutBesluittekstRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/bijlage': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutBijlageRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/overige-overwegingen': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutOverigeOverwegingenRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/procedurele-overwegingen': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutProcedureleOverwegingenRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/rechtsmiddelen': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutRechtsmiddelenRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/redirect': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutRedirectRoute
  '/beheer/standaardteksten/$grondslagId/$mapId/$sectieId/inhoudelijke-overwegingen': typeof BeheerStandaardtekstenGrondslagIdMapIdSectieIdInhoudelijkeOverwegingenRoute
  '/beheer/standaardteksten/$grondslagId/$mapId/$sectieId/voorschriften': typeof BeheerStandaardtekstenGrondslagIdMapIdSectieIdVoorschriftenRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/inhoudelijke-overwegingen/$hoofdstukId': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutInhoudelijkeOverwegingenHoofdstukIdRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/labels/$hoofdstukId': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutLabelsHoofdstukIdRoute
  '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/voorschriften/$hoofdstukId': typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutVoorschriftenHoofdstukIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/beheer'
    | '/500'
    | '/login_old'
    | '/$bedrijfLineageId/viewer'
    | '/beheer/activiteiten'
    | '/beheer/installatietypes'
    | '/beheer/labels'
    | '/$bedrijfLineageId/editor/$besluitId'
    | '/$bedrijfLineageId/viewer/vigerend'
    | '/$bedrijfLineageId/bedrijf'
    | '/beheer/labels/$mapId'
    | '/beheer/standaardteksten/$grondslagId'
    | '/$bedrijfLineageId/bedrijf/besluiten'
    | '/$bedrijfLineageId/bedrijf/historische-besluiten'
    | '/$bedrijfLineageId/bedrijf/ontwerpen'
    | '/$bedrijfLineageId/bedrijf/overzicht'
    | '/$bedrijfLineageId/editor/$besluitId/algemeen-toetsingskader'
    | '/$bedrijfLineageId/editor/$besluitId/begrippen'
    | '/$bedrijfLineageId/editor/$besluitId/besluittekst'
    | '/$bedrijfLineageId/editor/$besluitId/bijlage'
    | '/$bedrijfLineageId/editor/$besluitId/overige-overwegingen'
    | '/$bedrijfLineageId/editor/$besluitId/procedurele-overwegingen'
    | '/$bedrijfLineageId/editor/$besluitId/rechtsmiddelen'
    | '/$bedrijfLineageId/editor/$besluitId/redirect'
    | '/beheer/labels/$mapId/$nestedMapId'
    | '/beheer/standaardteksten/$grondslagId/$mapId'
    | '/$bedrijfLineageId/viewer/vigerend/'
    | '/$bedrijfLineageId/editor/$besluitId/inhoudelijke-overwegingen/$hoofdstukLineageId'
    | '/$bedrijfLineageId/editor/$besluitId/labels/$hoofdstukLineageId'
    | '/$bedrijfLineageId/editor/$besluitId/voorschriften/$hoofdstukLineageId'
    | '/$bedrijfLineageId/editor/$besluitId/voorschriften/hoofdstuk'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId'
    | '/$bedrijfLineageId/viewer/vigerend/inhoud/$hoofdstukLineageId'
    | '/$bedrijfLineageId/viewer/vigerend/labels/$hoofdstukLineageId'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/algemeen-toetsingskader'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/begrippen'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/besluittekst'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/bijlage'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/overige-overwegingen'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/procedurele-overwegingen'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/rechtsmiddelen'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/redirect'
    | '/beheer/standaardteksten/$grondslagId/$mapId/$sectieId/inhoudelijke-overwegingen'
    | '/beheer/standaardteksten/$grondslagId/$mapId/$sectieId/voorschriften'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/inhoudelijke-overwegingen/$hoofdstukId'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/labels/$hoofdstukId'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/voorschriften/$hoofdstukId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/beheer'
    | '/500'
    | '/login_old'
    | '/$bedrijfLineageId/viewer'
    | '/beheer/activiteiten'
    | '/beheer/installatietypes'
    | '/beheer/labels'
    | '/$bedrijfLineageId/editor/$besluitId'
    | '/$bedrijfLineageId/bedrijf'
    | '/beheer/labels/$mapId'
    | '/beheer/standaardteksten/$grondslagId'
    | '/$bedrijfLineageId/bedrijf/besluiten'
    | '/$bedrijfLineageId/bedrijf/historische-besluiten'
    | '/$bedrijfLineageId/bedrijf/ontwerpen'
    | '/$bedrijfLineageId/bedrijf/overzicht'
    | '/$bedrijfLineageId/editor/$besluitId/algemeen-toetsingskader'
    | '/$bedrijfLineageId/editor/$besluitId/begrippen'
    | '/$bedrijfLineageId/editor/$besluitId/besluittekst'
    | '/$bedrijfLineageId/editor/$besluitId/bijlage'
    | '/$bedrijfLineageId/editor/$besluitId/overige-overwegingen'
    | '/$bedrijfLineageId/editor/$besluitId/procedurele-overwegingen'
    | '/$bedrijfLineageId/editor/$besluitId/rechtsmiddelen'
    | '/$bedrijfLineageId/editor/$besluitId/redirect'
    | '/beheer/labels/$mapId/$nestedMapId'
    | '/beheer/standaardteksten/$grondslagId/$mapId'
    | '/$bedrijfLineageId/viewer/vigerend'
    | '/$bedrijfLineageId/editor/$besluitId/inhoudelijke-overwegingen/$hoofdstukLineageId'
    | '/$bedrijfLineageId/editor/$besluitId/labels/$hoofdstukLineageId'
    | '/$bedrijfLineageId/editor/$besluitId/voorschriften/$hoofdstukLineageId'
    | '/$bedrijfLineageId/editor/$besluitId/voorschriften/hoofdstuk'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId'
    | '/$bedrijfLineageId/viewer/vigerend/inhoud/$hoofdstukLineageId'
    | '/$bedrijfLineageId/viewer/vigerend/labels/$hoofdstukLineageId'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/algemeen-toetsingskader'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/begrippen'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/besluittekst'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/bijlage'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/overige-overwegingen'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/procedurele-overwegingen'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/rechtsmiddelen'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/redirect'
    | '/beheer/standaardteksten/$grondslagId/$mapId/$sectieId/inhoudelijke-overwegingen'
    | '/beheer/standaardteksten/$grondslagId/$mapId/$sectieId/voorschriften'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/inhoudelijke-overwegingen/$hoofdstukId'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/labels/$hoofdstukId'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/voorschriften/$hoofdstukId'
  id:
    | '__root__'
    | '/'
    | '/beheer'
    | '/500'
    | '/login_old'
    | '/$bedrijfLineageId/viewer'
    | '/beheer/activiteiten'
    | '/beheer/installatietypes'
    | '/beheer/labels'
    | '/$bedrijfLineageId/editor/$besluitId'
    | '/$bedrijfLineageId/viewer/vigerend'
    | '/$bedrijfLineageId/bedrijf/_layout'
    | '/beheer/labels/$mapId'
    | '/beheer/standaardteksten/$grondslagId'
    | '/$bedrijfLineageId/bedrijf/_layout/besluiten'
    | '/$bedrijfLineageId/bedrijf/_layout/historische-besluiten'
    | '/$bedrijfLineageId/bedrijf/_layout/ontwerpen'
    | '/$bedrijfLineageId/bedrijf/_layout/overzicht'
    | '/$bedrijfLineageId/editor/$besluitId/algemeen-toetsingskader'
    | '/$bedrijfLineageId/editor/$besluitId/begrippen'
    | '/$bedrijfLineageId/editor/$besluitId/besluittekst'
    | '/$bedrijfLineageId/editor/$besluitId/bijlage'
    | '/$bedrijfLineageId/editor/$besluitId/overige-overwegingen'
    | '/$bedrijfLineageId/editor/$besluitId/procedurele-overwegingen'
    | '/$bedrijfLineageId/editor/$besluitId/rechtsmiddelen'
    | '/$bedrijfLineageId/editor/$besluitId/redirect'
    | '/beheer/labels/$mapId/$nestedMapId'
    | '/beheer/standaardteksten/$grondslagId/$mapId'
    | '/$bedrijfLineageId/viewer/vigerend/'
    | '/$bedrijfLineageId/editor/$besluitId/inhoudelijke-overwegingen/$hoofdstukLineageId'
    | '/$bedrijfLineageId/editor/$besluitId/labels/$hoofdstukLineageId'
    | '/$bedrijfLineageId/editor/$besluitId/voorschriften/$hoofdstukLineageId'
    | '/$bedrijfLineageId/editor/$besluitId/voorschriften/hoofdstuk'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout'
    | '/$bedrijfLineageId/viewer/vigerend/inhoud/$hoofdstukLineageId'
    | '/$bedrijfLineageId/viewer/vigerend/labels/$hoofdstukLineageId'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/algemeen-toetsingskader'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/begrippen'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/besluittekst'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/bijlage'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/overige-overwegingen'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/procedurele-overwegingen'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/rechtsmiddelen'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/redirect'
    | '/beheer/standaardteksten/$grondslagId/$mapId/$sectieId/inhoudelijke-overwegingen'
    | '/beheer/standaardteksten/$grondslagId/$mapId/$sectieId/voorschriften'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/inhoudelijke-overwegingen/$hoofdstukId'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/labels/$hoofdstukId'
    | '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/voorschriften/$hoofdstukId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BeheerRouteRoute: typeof BeheerRouteRouteWithChildren
  R500Route: typeof R500Route
  Login_oldRoute: typeof Login_oldRoute
  BedrijfLineageIdViewerRouteRoute: typeof BedrijfLineageIdViewerRouteRouteWithChildren
  BedrijfLineageIdEditorBesluitIdRouteRoute: typeof BedrijfLineageIdEditorBesluitIdRouteRouteWithChildren
  BedrijfLineageIdBedrijfLayoutRoute: typeof BedrijfLineageIdBedrijfLayoutRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login_old': {
      id: '/login_old'
      path: '/login_old'
      fullPath: '/login_old'
      preLoaderRoute: typeof Login_oldRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/500': {
      id: '/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof R500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer': {
      id: '/beheer'
      path: '/beheer'
      fullPath: '/beheer'
      preLoaderRoute: typeof BeheerRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/labels': {
      id: '/beheer/labels'
      path: '/labels'
      fullPath: '/beheer/labels'
      preLoaderRoute: typeof BeheerLabelsRouteImport
      parentRoute: typeof BeheerRouteRoute
    }
    '/beheer/installatietypes': {
      id: '/beheer/installatietypes'
      path: '/installatietypes'
      fullPath: '/beheer/installatietypes'
      preLoaderRoute: typeof BeheerInstallatietypesRouteImport
      parentRoute: typeof BeheerRouteRoute
    }
    '/beheer/activiteiten': {
      id: '/beheer/activiteiten'
      path: '/activiteiten'
      fullPath: '/beheer/activiteiten'
      preLoaderRoute: typeof BeheerActiviteitenRouteImport
      parentRoute: typeof BeheerRouteRoute
    }
    '/$bedrijfLineageId/viewer': {
      id: '/$bedrijfLineageId/viewer'
      path: '/$bedrijfLineageId/viewer'
      fullPath: '/$bedrijfLineageId/viewer'
      preLoaderRoute: typeof BedrijfLineageIdViewerRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/standaardteksten/$grondslagId': {
      id: '/beheer/standaardteksten/$grondslagId'
      path: '/standaardteksten/$grondslagId'
      fullPath: '/beheer/standaardteksten/$grondslagId'
      preLoaderRoute: typeof BeheerStandaardtekstenGrondslagIdRouteImport
      parentRoute: typeof BeheerRouteRoute
    }
    '/beheer/labels/$mapId': {
      id: '/beheer/labels/$mapId'
      path: '/$mapId'
      fullPath: '/beheer/labels/$mapId'
      preLoaderRoute: typeof BeheerLabelsMapIdRouteImport
      parentRoute: typeof BeheerLabelsRoute
    }
    '/$bedrijfLineageId/bedrijf/_layout': {
      id: '/$bedrijfLineageId/bedrijf/_layout'
      path: '/$bedrijfLineageId/bedrijf'
      fullPath: '/$bedrijfLineageId/bedrijf'
      preLoaderRoute: typeof BedrijfLineageIdBedrijfLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$bedrijfLineageId/viewer/vigerend': {
      id: '/$bedrijfLineageId/viewer/vigerend'
      path: '/vigerend'
      fullPath: '/$bedrijfLineageId/viewer/vigerend'
      preLoaderRoute: typeof BedrijfLineageIdViewerVigerendRouteRouteImport
      parentRoute: typeof BedrijfLineageIdViewerRouteRoute
    }
    '/$bedrijfLineageId/editor/$besluitId': {
      id: '/$bedrijfLineageId/editor/$besluitId'
      path: '/$bedrijfLineageId/editor/$besluitId'
      fullPath: '/$bedrijfLineageId/editor/$besluitId'
      preLoaderRoute: typeof BedrijfLineageIdEditorBesluitIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$bedrijfLineageId/viewer/vigerend/': {
      id: '/$bedrijfLineageId/viewer/vigerend/'
      path: '/'
      fullPath: '/$bedrijfLineageId/viewer/vigerend/'
      preLoaderRoute: typeof BedrijfLineageIdViewerVigerendIndexRouteImport
      parentRoute: typeof BedrijfLineageIdViewerVigerendRouteRoute
    }
    '/beheer/standaardteksten/$grondslagId/$mapId': {
      id: '/beheer/standaardteksten/$grondslagId/$mapId'
      path: '/$mapId'
      fullPath: '/beheer/standaardteksten/$grondslagId/$mapId'
      preLoaderRoute: typeof BeheerStandaardtekstenGrondslagIdMapIdRouteImport
      parentRoute: typeof BeheerStandaardtekstenGrondslagIdRoute
    }
    '/beheer/labels/$mapId/$nestedMapId': {
      id: '/beheer/labels/$mapId/$nestedMapId'
      path: '/$nestedMapId'
      fullPath: '/beheer/labels/$mapId/$nestedMapId'
      preLoaderRoute: typeof BeheerLabelsMapIdNestedMapIdRouteImport
      parentRoute: typeof BeheerLabelsMapIdRoute
    }
    '/$bedrijfLineageId/editor/$besluitId/redirect': {
      id: '/$bedrijfLineageId/editor/$besluitId/redirect'
      path: '/redirect'
      fullPath: '/$bedrijfLineageId/editor/$besluitId/redirect'
      preLoaderRoute: typeof BedrijfLineageIdEditorBesluitIdRedirectRouteImport
      parentRoute: typeof BedrijfLineageIdEditorBesluitIdRouteRoute
    }
    '/$bedrijfLineageId/editor/$besluitId/rechtsmiddelen': {
      id: '/$bedrijfLineageId/editor/$besluitId/rechtsmiddelen'
      path: '/rechtsmiddelen'
      fullPath: '/$bedrijfLineageId/editor/$besluitId/rechtsmiddelen'
      preLoaderRoute: typeof BedrijfLineageIdEditorBesluitIdRechtsmiddelenRouteImport
      parentRoute: typeof BedrijfLineageIdEditorBesluitIdRouteRoute
    }
    '/$bedrijfLineageId/editor/$besluitId/procedurele-overwegingen': {
      id: '/$bedrijfLineageId/editor/$besluitId/procedurele-overwegingen'
      path: '/procedurele-overwegingen'
      fullPath: '/$bedrijfLineageId/editor/$besluitId/procedurele-overwegingen'
      preLoaderRoute: typeof BedrijfLineageIdEditorBesluitIdProcedureleOverwegingenRouteImport
      parentRoute: typeof BedrijfLineageIdEditorBesluitIdRouteRoute
    }
    '/$bedrijfLineageId/editor/$besluitId/overige-overwegingen': {
      id: '/$bedrijfLineageId/editor/$besluitId/overige-overwegingen'
      path: '/overige-overwegingen'
      fullPath: '/$bedrijfLineageId/editor/$besluitId/overige-overwegingen'
      preLoaderRoute: typeof BedrijfLineageIdEditorBesluitIdOverigeOverwegingenRouteImport
      parentRoute: typeof BedrijfLineageIdEditorBesluitIdRouteRoute
    }
    '/$bedrijfLineageId/editor/$besluitId/bijlage': {
      id: '/$bedrijfLineageId/editor/$besluitId/bijlage'
      path: '/bijlage'
      fullPath: '/$bedrijfLineageId/editor/$besluitId/bijlage'
      preLoaderRoute: typeof BedrijfLineageIdEditorBesluitIdBijlageRouteImport
      parentRoute: typeof BedrijfLineageIdEditorBesluitIdRouteRoute
    }
    '/$bedrijfLineageId/editor/$besluitId/besluittekst': {
      id: '/$bedrijfLineageId/editor/$besluitId/besluittekst'
      path: '/besluittekst'
      fullPath: '/$bedrijfLineageId/editor/$besluitId/besluittekst'
      preLoaderRoute: typeof BedrijfLineageIdEditorBesluitIdBesluittekstRouteImport
      parentRoute: typeof BedrijfLineageIdEditorBesluitIdRouteRoute
    }
    '/$bedrijfLineageId/editor/$besluitId/begrippen': {
      id: '/$bedrijfLineageId/editor/$besluitId/begrippen'
      path: '/begrippen'
      fullPath: '/$bedrijfLineageId/editor/$besluitId/begrippen'
      preLoaderRoute: typeof BedrijfLineageIdEditorBesluitIdBegrippenRouteImport
      parentRoute: typeof BedrijfLineageIdEditorBesluitIdRouteRoute
    }
    '/$bedrijfLineageId/editor/$besluitId/algemeen-toetsingskader': {
      id: '/$bedrijfLineageId/editor/$besluitId/algemeen-toetsingskader'
      path: '/algemeen-toetsingskader'
      fullPath: '/$bedrijfLineageId/editor/$besluitId/algemeen-toetsingskader'
      preLoaderRoute: typeof BedrijfLineageIdEditorBesluitIdAlgemeenToetsingskaderRouteImport
      parentRoute: typeof BedrijfLineageIdEditorBesluitIdRouteRoute
    }
    '/$bedrijfLineageId/bedrijf/_layout/overzicht': {
      id: '/$bedrijfLineageId/bedrijf/_layout/overzicht'
      path: '/overzicht'
      fullPath: '/$bedrijfLineageId/bedrijf/overzicht'
      preLoaderRoute: typeof BedrijfLineageIdBedrijfLayoutOverzichtRouteImport
      parentRoute: typeof BedrijfLineageIdBedrijfLayoutRoute
    }
    '/$bedrijfLineageId/bedrijf/_layout/ontwerpen': {
      id: '/$bedrijfLineageId/bedrijf/_layout/ontwerpen'
      path: '/ontwerpen'
      fullPath: '/$bedrijfLineageId/bedrijf/ontwerpen'
      preLoaderRoute: typeof BedrijfLineageIdBedrijfLayoutOntwerpenRouteImport
      parentRoute: typeof BedrijfLineageIdBedrijfLayoutRoute
    }
    '/$bedrijfLineageId/bedrijf/_layout/historische-besluiten': {
      id: '/$bedrijfLineageId/bedrijf/_layout/historische-besluiten'
      path: '/historische-besluiten'
      fullPath: '/$bedrijfLineageId/bedrijf/historische-besluiten'
      preLoaderRoute: typeof BedrijfLineageIdBedrijfLayoutHistorischeBesluitenRouteImport
      parentRoute: typeof BedrijfLineageIdBedrijfLayoutRoute
    }
    '/$bedrijfLineageId/bedrijf/_layout/besluiten': {
      id: '/$bedrijfLineageId/bedrijf/_layout/besluiten'
      path: '/besluiten'
      fullPath: '/$bedrijfLineageId/bedrijf/besluiten'
      preLoaderRoute: typeof BedrijfLineageIdBedrijfLayoutBesluitenRouteImport
      parentRoute: typeof BedrijfLineageIdBedrijfLayoutRoute
    }
    '/$bedrijfLineageId/viewer/vigerend/labels/$hoofdstukLineageId': {
      id: '/$bedrijfLineageId/viewer/vigerend/labels/$hoofdstukLineageId'
      path: '/labels/$hoofdstukLineageId'
      fullPath: '/$bedrijfLineageId/viewer/vigerend/labels/$hoofdstukLineageId'
      preLoaderRoute: typeof BedrijfLineageIdViewerVigerendLabelsHoofdstukLineageIdRouteImport
      parentRoute: typeof BedrijfLineageIdViewerVigerendRouteRoute
    }
    '/$bedrijfLineageId/viewer/vigerend/inhoud/$hoofdstukLineageId': {
      id: '/$bedrijfLineageId/viewer/vigerend/inhoud/$hoofdstukLineageId'
      path: '/inhoud/$hoofdstukLineageId'
      fullPath: '/$bedrijfLineageId/viewer/vigerend/inhoud/$hoofdstukLineageId'
      preLoaderRoute: typeof BedrijfLineageIdViewerVigerendInhoudHoofdstukLineageIdRouteImport
      parentRoute: typeof BedrijfLineageIdViewerVigerendRouteRoute
    }
    '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout': {
      id: '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout'
      path: '/besluit/$besluitId'
      fullPath: '/$bedrijfLineageId/viewer/besluit/$besluitId'
      preLoaderRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutRouteImport
      parentRoute: typeof BedrijfLineageIdViewerRouteRoute
    }
    '/$bedrijfLineageId/editor/$besluitId/voorschriften/hoofdstuk': {
      id: '/$bedrijfLineageId/editor/$besluitId/voorschriften/hoofdstuk'
      path: '/voorschriften/hoofdstuk'
      fullPath: '/$bedrijfLineageId/editor/$besluitId/voorschriften/hoofdstuk'
      preLoaderRoute: typeof BedrijfLineageIdEditorBesluitIdVoorschriftenHoofdstukRouteImport
      parentRoute: typeof BedrijfLineageIdEditorBesluitIdRouteRoute
    }
    '/$bedrijfLineageId/editor/$besluitId/voorschriften/$hoofdstukLineageId': {
      id: '/$bedrijfLineageId/editor/$besluitId/voorschriften/$hoofdstukLineageId'
      path: '/voorschriften/$hoofdstukLineageId'
      fullPath: '/$bedrijfLineageId/editor/$besluitId/voorschriften/$hoofdstukLineageId'
      preLoaderRoute: typeof BedrijfLineageIdEditorBesluitIdVoorschriftenHoofdstukLineageIdRouteImport
      parentRoute: typeof BedrijfLineageIdEditorBesluitIdRouteRoute
    }
    '/$bedrijfLineageId/editor/$besluitId/labels/$hoofdstukLineageId': {
      id: '/$bedrijfLineageId/editor/$besluitId/labels/$hoofdstukLineageId'
      path: '/labels/$hoofdstukLineageId'
      fullPath: '/$bedrijfLineageId/editor/$besluitId/labels/$hoofdstukLineageId'
      preLoaderRoute: typeof BedrijfLineageIdEditorBesluitIdLabelsHoofdstukLineageIdRouteImport
      parentRoute: typeof BedrijfLineageIdEditorBesluitIdRouteRoute
    }
    '/$bedrijfLineageId/editor/$besluitId/inhoudelijke-overwegingen/$hoofdstukLineageId': {
      id: '/$bedrijfLineageId/editor/$besluitId/inhoudelijke-overwegingen/$hoofdstukLineageId'
      path: '/inhoudelijke-overwegingen/$hoofdstukLineageId'
      fullPath: '/$bedrijfLineageId/editor/$besluitId/inhoudelijke-overwegingen/$hoofdstukLineageId'
      preLoaderRoute: typeof BedrijfLineageIdEditorBesluitIdInhoudelijkeOverwegingenHoofdstukLineageIdRouteImport
      parentRoute: typeof BedrijfLineageIdEditorBesluitIdRouteRoute
    }
    '/beheer/standaardteksten/$grondslagId/$mapId/$sectieId/voorschriften': {
      id: '/beheer/standaardteksten/$grondslagId/$mapId/$sectieId/voorschriften'
      path: '/$sectieId/voorschriften'
      fullPath: '/beheer/standaardteksten/$grondslagId/$mapId/$sectieId/voorschriften'
      preLoaderRoute: typeof BeheerStandaardtekstenGrondslagIdMapIdSectieIdVoorschriftenRouteImport
      parentRoute: typeof BeheerStandaardtekstenGrondslagIdMapIdRoute
    }
    '/beheer/standaardteksten/$grondslagId/$mapId/$sectieId/inhoudelijke-overwegingen': {
      id: '/beheer/standaardteksten/$grondslagId/$mapId/$sectieId/inhoudelijke-overwegingen'
      path: '/$sectieId/inhoudelijke-overwegingen'
      fullPath: '/beheer/standaardteksten/$grondslagId/$mapId/$sectieId/inhoudelijke-overwegingen'
      preLoaderRoute: typeof BeheerStandaardtekstenGrondslagIdMapIdSectieIdInhoudelijkeOverwegingenRouteImport
      parentRoute: typeof BeheerStandaardtekstenGrondslagIdMapIdRoute
    }
    '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/redirect': {
      id: '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/redirect'
      path: '/redirect'
      fullPath: '/$bedrijfLineageId/viewer/besluit/$besluitId/redirect'
      preLoaderRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutRedirectRouteImport
      parentRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutRoute
    }
    '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/rechtsmiddelen': {
      id: '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/rechtsmiddelen'
      path: '/rechtsmiddelen'
      fullPath: '/$bedrijfLineageId/viewer/besluit/$besluitId/rechtsmiddelen'
      preLoaderRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutRechtsmiddelenRouteImport
      parentRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutRoute
    }
    '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/procedurele-overwegingen': {
      id: '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/procedurele-overwegingen'
      path: '/procedurele-overwegingen'
      fullPath: '/$bedrijfLineageId/viewer/besluit/$besluitId/procedurele-overwegingen'
      preLoaderRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutProcedureleOverwegingenRouteImport
      parentRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutRoute
    }
    '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/overige-overwegingen': {
      id: '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/overige-overwegingen'
      path: '/overige-overwegingen'
      fullPath: '/$bedrijfLineageId/viewer/besluit/$besluitId/overige-overwegingen'
      preLoaderRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutOverigeOverwegingenRouteImport
      parentRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutRoute
    }
    '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/bijlage': {
      id: '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/bijlage'
      path: '/bijlage'
      fullPath: '/$bedrijfLineageId/viewer/besluit/$besluitId/bijlage'
      preLoaderRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutBijlageRouteImport
      parentRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutRoute
    }
    '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/besluittekst': {
      id: '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/besluittekst'
      path: '/besluittekst'
      fullPath: '/$bedrijfLineageId/viewer/besluit/$besluitId/besluittekst'
      preLoaderRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutBesluittekstRouteImport
      parentRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutRoute
    }
    '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/begrippen': {
      id: '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/begrippen'
      path: '/begrippen'
      fullPath: '/$bedrijfLineageId/viewer/besluit/$besluitId/begrippen'
      preLoaderRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutBegrippenRouteImport
      parentRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutRoute
    }
    '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/algemeen-toetsingskader': {
      id: '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/algemeen-toetsingskader'
      path: '/algemeen-toetsingskader'
      fullPath: '/$bedrijfLineageId/viewer/besluit/$besluitId/algemeen-toetsingskader'
      preLoaderRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutAlgemeenToetsingskaderRouteImport
      parentRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutRoute
    }
    '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/voorschriften/$hoofdstukId': {
      id: '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/voorschriften/$hoofdstukId'
      path: '/voorschriften/$hoofdstukId'
      fullPath: '/$bedrijfLineageId/viewer/besluit/$besluitId/voorschriften/$hoofdstukId'
      preLoaderRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutVoorschriftenHoofdstukIdRouteImport
      parentRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutRoute
    }
    '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/labels/$hoofdstukId': {
      id: '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/labels/$hoofdstukId'
      path: '/labels/$hoofdstukId'
      fullPath: '/$bedrijfLineageId/viewer/besluit/$besluitId/labels/$hoofdstukId'
      preLoaderRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutLabelsHoofdstukIdRouteImport
      parentRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutRoute
    }
    '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/inhoudelijke-overwegingen/$hoofdstukId': {
      id: '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/inhoudelijke-overwegingen/$hoofdstukId'
      path: '/inhoudelijke-overwegingen/$hoofdstukId'
      fullPath: '/$bedrijfLineageId/viewer/besluit/$besluitId/inhoudelijke-overwegingen/$hoofdstukId'
      preLoaderRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutInhoudelijkeOverwegingenHoofdstukIdRouteImport
      parentRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutRoute
    }
  }
}

interface BeheerLabelsMapIdRouteChildren {
  BeheerLabelsMapIdNestedMapIdRoute: typeof BeheerLabelsMapIdNestedMapIdRoute
}

const BeheerLabelsMapIdRouteChildren: BeheerLabelsMapIdRouteChildren = {
  BeheerLabelsMapIdNestedMapIdRoute: BeheerLabelsMapIdNestedMapIdRoute,
}

const BeheerLabelsMapIdRouteWithChildren =
  BeheerLabelsMapIdRoute._addFileChildren(BeheerLabelsMapIdRouteChildren)

interface BeheerLabelsRouteChildren {
  BeheerLabelsMapIdRoute: typeof BeheerLabelsMapIdRouteWithChildren
}

const BeheerLabelsRouteChildren: BeheerLabelsRouteChildren = {
  BeheerLabelsMapIdRoute: BeheerLabelsMapIdRouteWithChildren,
}

const BeheerLabelsRouteWithChildren = BeheerLabelsRoute._addFileChildren(
  BeheerLabelsRouteChildren,
)

interface BeheerStandaardtekstenGrondslagIdMapIdRouteChildren {
  BeheerStandaardtekstenGrondslagIdMapIdSectieIdInhoudelijkeOverwegingenRoute: typeof BeheerStandaardtekstenGrondslagIdMapIdSectieIdInhoudelijkeOverwegingenRoute
  BeheerStandaardtekstenGrondslagIdMapIdSectieIdVoorschriftenRoute: typeof BeheerStandaardtekstenGrondslagIdMapIdSectieIdVoorschriftenRoute
}

const BeheerStandaardtekstenGrondslagIdMapIdRouteChildren: BeheerStandaardtekstenGrondslagIdMapIdRouteChildren =
  {
    BeheerStandaardtekstenGrondslagIdMapIdSectieIdInhoudelijkeOverwegingenRoute:
      BeheerStandaardtekstenGrondslagIdMapIdSectieIdInhoudelijkeOverwegingenRoute,
    BeheerStandaardtekstenGrondslagIdMapIdSectieIdVoorschriftenRoute:
      BeheerStandaardtekstenGrondslagIdMapIdSectieIdVoorschriftenRoute,
  }

const BeheerStandaardtekstenGrondslagIdMapIdRouteWithChildren =
  BeheerStandaardtekstenGrondslagIdMapIdRoute._addFileChildren(
    BeheerStandaardtekstenGrondslagIdMapIdRouteChildren,
  )

interface BeheerStandaardtekstenGrondslagIdRouteChildren {
  BeheerStandaardtekstenGrondslagIdMapIdRoute: typeof BeheerStandaardtekstenGrondslagIdMapIdRouteWithChildren
}

const BeheerStandaardtekstenGrondslagIdRouteChildren: BeheerStandaardtekstenGrondslagIdRouteChildren =
  {
    BeheerStandaardtekstenGrondslagIdMapIdRoute:
      BeheerStandaardtekstenGrondslagIdMapIdRouteWithChildren,
  }

const BeheerStandaardtekstenGrondslagIdRouteWithChildren =
  BeheerStandaardtekstenGrondslagIdRoute._addFileChildren(
    BeheerStandaardtekstenGrondslagIdRouteChildren,
  )

interface BeheerRouteRouteChildren {
  BeheerActiviteitenRoute: typeof BeheerActiviteitenRoute
  BeheerInstallatietypesRoute: typeof BeheerInstallatietypesRoute
  BeheerLabelsRoute: typeof BeheerLabelsRouteWithChildren
  BeheerStandaardtekstenGrondslagIdRoute: typeof BeheerStandaardtekstenGrondslagIdRouteWithChildren
}

const BeheerRouteRouteChildren: BeheerRouteRouteChildren = {
  BeheerActiviteitenRoute: BeheerActiviteitenRoute,
  BeheerInstallatietypesRoute: BeheerInstallatietypesRoute,
  BeheerLabelsRoute: BeheerLabelsRouteWithChildren,
  BeheerStandaardtekstenGrondslagIdRoute:
    BeheerStandaardtekstenGrondslagIdRouteWithChildren,
}

const BeheerRouteRouteWithChildren = BeheerRouteRoute._addFileChildren(
  BeheerRouteRouteChildren,
)

interface BedrijfLineageIdViewerVigerendRouteRouteChildren {
  BedrijfLineageIdViewerVigerendIndexRoute: typeof BedrijfLineageIdViewerVigerendIndexRoute
  BedrijfLineageIdViewerVigerendInhoudHoofdstukLineageIdRoute: typeof BedrijfLineageIdViewerVigerendInhoudHoofdstukLineageIdRoute
  BedrijfLineageIdViewerVigerendLabelsHoofdstukLineageIdRoute: typeof BedrijfLineageIdViewerVigerendLabelsHoofdstukLineageIdRoute
}

const BedrijfLineageIdViewerVigerendRouteRouteChildren: BedrijfLineageIdViewerVigerendRouteRouteChildren =
  {
    BedrijfLineageIdViewerVigerendIndexRoute:
      BedrijfLineageIdViewerVigerendIndexRoute,
    BedrijfLineageIdViewerVigerendInhoudHoofdstukLineageIdRoute:
      BedrijfLineageIdViewerVigerendInhoudHoofdstukLineageIdRoute,
    BedrijfLineageIdViewerVigerendLabelsHoofdstukLineageIdRoute:
      BedrijfLineageIdViewerVigerendLabelsHoofdstukLineageIdRoute,
  }

const BedrijfLineageIdViewerVigerendRouteRouteWithChildren =
  BedrijfLineageIdViewerVigerendRouteRoute._addFileChildren(
    BedrijfLineageIdViewerVigerendRouteRouteChildren,
  )

interface BedrijfLineageIdViewerBesluitBesluitIdLayoutRouteChildren {
  BedrijfLineageIdViewerBesluitBesluitIdLayoutAlgemeenToetsingskaderRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutAlgemeenToetsingskaderRoute
  BedrijfLineageIdViewerBesluitBesluitIdLayoutBegrippenRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutBegrippenRoute
  BedrijfLineageIdViewerBesluitBesluitIdLayoutBesluittekstRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutBesluittekstRoute
  BedrijfLineageIdViewerBesluitBesluitIdLayoutBijlageRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutBijlageRoute
  BedrijfLineageIdViewerBesluitBesluitIdLayoutOverigeOverwegingenRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutOverigeOverwegingenRoute
  BedrijfLineageIdViewerBesluitBesluitIdLayoutProcedureleOverwegingenRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutProcedureleOverwegingenRoute
  BedrijfLineageIdViewerBesluitBesluitIdLayoutRechtsmiddelenRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutRechtsmiddelenRoute
  BedrijfLineageIdViewerBesluitBesluitIdLayoutRedirectRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutRedirectRoute
  BedrijfLineageIdViewerBesluitBesluitIdLayoutInhoudelijkeOverwegingenHoofdstukIdRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutInhoudelijkeOverwegingenHoofdstukIdRoute
  BedrijfLineageIdViewerBesluitBesluitIdLayoutLabelsHoofdstukIdRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutLabelsHoofdstukIdRoute
  BedrijfLineageIdViewerBesluitBesluitIdLayoutVoorschriftenHoofdstukIdRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutVoorschriftenHoofdstukIdRoute
}

const BedrijfLineageIdViewerBesluitBesluitIdLayoutRouteChildren: BedrijfLineageIdViewerBesluitBesluitIdLayoutRouteChildren =
  {
    BedrijfLineageIdViewerBesluitBesluitIdLayoutAlgemeenToetsingskaderRoute:
      BedrijfLineageIdViewerBesluitBesluitIdLayoutAlgemeenToetsingskaderRoute,
    BedrijfLineageIdViewerBesluitBesluitIdLayoutBegrippenRoute:
      BedrijfLineageIdViewerBesluitBesluitIdLayoutBegrippenRoute,
    BedrijfLineageIdViewerBesluitBesluitIdLayoutBesluittekstRoute:
      BedrijfLineageIdViewerBesluitBesluitIdLayoutBesluittekstRoute,
    BedrijfLineageIdViewerBesluitBesluitIdLayoutBijlageRoute:
      BedrijfLineageIdViewerBesluitBesluitIdLayoutBijlageRoute,
    BedrijfLineageIdViewerBesluitBesluitIdLayoutOverigeOverwegingenRoute:
      BedrijfLineageIdViewerBesluitBesluitIdLayoutOverigeOverwegingenRoute,
    BedrijfLineageIdViewerBesluitBesluitIdLayoutProcedureleOverwegingenRoute:
      BedrijfLineageIdViewerBesluitBesluitIdLayoutProcedureleOverwegingenRoute,
    BedrijfLineageIdViewerBesluitBesluitIdLayoutRechtsmiddelenRoute:
      BedrijfLineageIdViewerBesluitBesluitIdLayoutRechtsmiddelenRoute,
    BedrijfLineageIdViewerBesluitBesluitIdLayoutRedirectRoute:
      BedrijfLineageIdViewerBesluitBesluitIdLayoutRedirectRoute,
    BedrijfLineageIdViewerBesluitBesluitIdLayoutInhoudelijkeOverwegingenHoofdstukIdRoute:
      BedrijfLineageIdViewerBesluitBesluitIdLayoutInhoudelijkeOverwegingenHoofdstukIdRoute,
    BedrijfLineageIdViewerBesluitBesluitIdLayoutLabelsHoofdstukIdRoute:
      BedrijfLineageIdViewerBesluitBesluitIdLayoutLabelsHoofdstukIdRoute,
    BedrijfLineageIdViewerBesluitBesluitIdLayoutVoorschriftenHoofdstukIdRoute:
      BedrijfLineageIdViewerBesluitBesluitIdLayoutVoorschriftenHoofdstukIdRoute,
  }

const BedrijfLineageIdViewerBesluitBesluitIdLayoutRouteWithChildren =
  BedrijfLineageIdViewerBesluitBesluitIdLayoutRoute._addFileChildren(
    BedrijfLineageIdViewerBesluitBesluitIdLayoutRouteChildren,
  )

interface BedrijfLineageIdViewerRouteRouteChildren {
  BedrijfLineageIdViewerVigerendRouteRoute: typeof BedrijfLineageIdViewerVigerendRouteRouteWithChildren
  BedrijfLineageIdViewerBesluitBesluitIdLayoutRoute: typeof BedrijfLineageIdViewerBesluitBesluitIdLayoutRouteWithChildren
}

const BedrijfLineageIdViewerRouteRouteChildren: BedrijfLineageIdViewerRouteRouteChildren =
  {
    BedrijfLineageIdViewerVigerendRouteRoute:
      BedrijfLineageIdViewerVigerendRouteRouteWithChildren,
    BedrijfLineageIdViewerBesluitBesluitIdLayoutRoute:
      BedrijfLineageIdViewerBesluitBesluitIdLayoutRouteWithChildren,
  }

const BedrijfLineageIdViewerRouteRouteWithChildren =
  BedrijfLineageIdViewerRouteRoute._addFileChildren(
    BedrijfLineageIdViewerRouteRouteChildren,
  )

interface BedrijfLineageIdEditorBesluitIdRouteRouteChildren {
  BedrijfLineageIdEditorBesluitIdAlgemeenToetsingskaderRoute: typeof BedrijfLineageIdEditorBesluitIdAlgemeenToetsingskaderRoute
  BedrijfLineageIdEditorBesluitIdBegrippenRoute: typeof BedrijfLineageIdEditorBesluitIdBegrippenRoute
  BedrijfLineageIdEditorBesluitIdBesluittekstRoute: typeof BedrijfLineageIdEditorBesluitIdBesluittekstRoute
  BedrijfLineageIdEditorBesluitIdBijlageRoute: typeof BedrijfLineageIdEditorBesluitIdBijlageRoute
  BedrijfLineageIdEditorBesluitIdOverigeOverwegingenRoute: typeof BedrijfLineageIdEditorBesluitIdOverigeOverwegingenRoute
  BedrijfLineageIdEditorBesluitIdProcedureleOverwegingenRoute: typeof BedrijfLineageIdEditorBesluitIdProcedureleOverwegingenRoute
  BedrijfLineageIdEditorBesluitIdRechtsmiddelenRoute: typeof BedrijfLineageIdEditorBesluitIdRechtsmiddelenRoute
  BedrijfLineageIdEditorBesluitIdRedirectRoute: typeof BedrijfLineageIdEditorBesluitIdRedirectRoute
  BedrijfLineageIdEditorBesluitIdInhoudelijkeOverwegingenHoofdstukLineageIdRoute: typeof BedrijfLineageIdEditorBesluitIdInhoudelijkeOverwegingenHoofdstukLineageIdRoute
  BedrijfLineageIdEditorBesluitIdLabelsHoofdstukLineageIdRoute: typeof BedrijfLineageIdEditorBesluitIdLabelsHoofdstukLineageIdRoute
  BedrijfLineageIdEditorBesluitIdVoorschriftenHoofdstukLineageIdRoute: typeof BedrijfLineageIdEditorBesluitIdVoorschriftenHoofdstukLineageIdRoute
  BedrijfLineageIdEditorBesluitIdVoorschriftenHoofdstukRoute: typeof BedrijfLineageIdEditorBesluitIdVoorschriftenHoofdstukRoute
}

const BedrijfLineageIdEditorBesluitIdRouteRouteChildren: BedrijfLineageIdEditorBesluitIdRouteRouteChildren =
  {
    BedrijfLineageIdEditorBesluitIdAlgemeenToetsingskaderRoute:
      BedrijfLineageIdEditorBesluitIdAlgemeenToetsingskaderRoute,
    BedrijfLineageIdEditorBesluitIdBegrippenRoute:
      BedrijfLineageIdEditorBesluitIdBegrippenRoute,
    BedrijfLineageIdEditorBesluitIdBesluittekstRoute:
      BedrijfLineageIdEditorBesluitIdBesluittekstRoute,
    BedrijfLineageIdEditorBesluitIdBijlageRoute:
      BedrijfLineageIdEditorBesluitIdBijlageRoute,
    BedrijfLineageIdEditorBesluitIdOverigeOverwegingenRoute:
      BedrijfLineageIdEditorBesluitIdOverigeOverwegingenRoute,
    BedrijfLineageIdEditorBesluitIdProcedureleOverwegingenRoute:
      BedrijfLineageIdEditorBesluitIdProcedureleOverwegingenRoute,
    BedrijfLineageIdEditorBesluitIdRechtsmiddelenRoute:
      BedrijfLineageIdEditorBesluitIdRechtsmiddelenRoute,
    BedrijfLineageIdEditorBesluitIdRedirectRoute:
      BedrijfLineageIdEditorBesluitIdRedirectRoute,
    BedrijfLineageIdEditorBesluitIdInhoudelijkeOverwegingenHoofdstukLineageIdRoute:
      BedrijfLineageIdEditorBesluitIdInhoudelijkeOverwegingenHoofdstukLineageIdRoute,
    BedrijfLineageIdEditorBesluitIdLabelsHoofdstukLineageIdRoute:
      BedrijfLineageIdEditorBesluitIdLabelsHoofdstukLineageIdRoute,
    BedrijfLineageIdEditorBesluitIdVoorschriftenHoofdstukLineageIdRoute:
      BedrijfLineageIdEditorBesluitIdVoorschriftenHoofdstukLineageIdRoute,
    BedrijfLineageIdEditorBesluitIdVoorschriftenHoofdstukRoute:
      BedrijfLineageIdEditorBesluitIdVoorschriftenHoofdstukRoute,
  }

const BedrijfLineageIdEditorBesluitIdRouteRouteWithChildren =
  BedrijfLineageIdEditorBesluitIdRouteRoute._addFileChildren(
    BedrijfLineageIdEditorBesluitIdRouteRouteChildren,
  )

interface BedrijfLineageIdBedrijfLayoutRouteChildren {
  BedrijfLineageIdBedrijfLayoutBesluitenRoute: typeof BedrijfLineageIdBedrijfLayoutBesluitenRoute
  BedrijfLineageIdBedrijfLayoutHistorischeBesluitenRoute: typeof BedrijfLineageIdBedrijfLayoutHistorischeBesluitenRoute
  BedrijfLineageIdBedrijfLayoutOntwerpenRoute: typeof BedrijfLineageIdBedrijfLayoutOntwerpenRoute
  BedrijfLineageIdBedrijfLayoutOverzichtRoute: typeof BedrijfLineageIdBedrijfLayoutOverzichtRoute
}

const BedrijfLineageIdBedrijfLayoutRouteChildren: BedrijfLineageIdBedrijfLayoutRouteChildren =
  {
    BedrijfLineageIdBedrijfLayoutBesluitenRoute:
      BedrijfLineageIdBedrijfLayoutBesluitenRoute,
    BedrijfLineageIdBedrijfLayoutHistorischeBesluitenRoute:
      BedrijfLineageIdBedrijfLayoutHistorischeBesluitenRoute,
    BedrijfLineageIdBedrijfLayoutOntwerpenRoute:
      BedrijfLineageIdBedrijfLayoutOntwerpenRoute,
    BedrijfLineageIdBedrijfLayoutOverzichtRoute:
      BedrijfLineageIdBedrijfLayoutOverzichtRoute,
  }

const BedrijfLineageIdBedrijfLayoutRouteWithChildren =
  BedrijfLineageIdBedrijfLayoutRoute._addFileChildren(
    BedrijfLineageIdBedrijfLayoutRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BeheerRouteRoute: BeheerRouteRouteWithChildren,
  R500Route: R500Route,
  Login_oldRoute: Login_oldRoute,
  BedrijfLineageIdViewerRouteRoute:
    BedrijfLineageIdViewerRouteRouteWithChildren,
  BedrijfLineageIdEditorBesluitIdRouteRoute:
    BedrijfLineageIdEditorBesluitIdRouteRouteWithChildren,
  BedrijfLineageIdBedrijfLayoutRoute:
    BedrijfLineageIdBedrijfLayoutRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
